import t from"react";import e from"xss";const r=({content:r})=>r?t.createElement("div",{dangerouslySetInnerHTML:{__html:e(r)}}):null;export{r as Text};
//# sourceMappingURL=index.js.map
